export default "__VITE_ASSET__1wgquOQw__"